import React from 'react';
import { SEO } from '../components/seo/SEO';
import { MarkdownPage } from '../components/content/MarkdownPage';
import content from '../content/insights/ai-governance.md?raw';

export const InsightsAIGovernance: React.FC = () => {
  return (
    <>
      <SEO
        title="AI Governance & LLMOps: EU-Ready, Production-First"
        description="How to make AI/LLM systems production-ready with EU AI Act awareness, guardrails, observability, and secure integration into SAP/ERP landscapes."
        canonical="/insights/ai-governance"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'AI Governance & LLMOps: EU-Ready, Production-First',
          description:
            'How to make AI/LLM systems production-ready with EU AI Act awareness, guardrails, observability, and secure integration into SAP/ERP landscapes.',
          author: { '@type': 'Organization', name: 'Integrova AI GmbH' },
          publisher: {
            '@type': 'Organization',
            name: 'Integrova AI GmbH',
            logo: { '@type': 'ImageObject', url: 'https://integrovaai.de/og-default.png' },
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://integrovaai.de/insights/ai-governance' },
          datePublished: '2025-12-20',
          dateModified: '2025-12-20',
        }}
      />
      <MarkdownPage
        title="AI Governance & LLMOps: EU-Ready, Production-First"
        content={content}
        eyebrow="Insights"
      />
    </>
  );
};

export default InsightsAIGovernance;
